import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(theme => ({
 
}))

const BusinessDetails = ({
  slotConfig
}) => {
  const classes = useStyles()
  
  return (
    <>
      {
        slotConfig && slotConfig.business && slotConfig.business.name && (
          <Typography gutterBottom>
            Name: <strong>{ slotConfig.business.name }</strong>
          </Typography>
        )
      }
      {
        slotConfig && slotConfig.business && slotConfig.business.email && (
          <Typography gutterBottom>
            Email: <strong>{ slotConfig.business.email }</strong>
          </Typography>
        )
      }
      {
        slotConfig && slotConfig.business && slotConfig.business.phone && (
          <Typography gutterBottom>
            Phone: <strong>{ slotConfig.business.phone }</strong>
          </Typography>
        )
      }
    </>
  )
}

export default BusinessDetails